export const KidStoriesData = [
    {
      id: 1,
      title: "How the Space War Begin? Please watch this",
      thumbnail: "https://graphicdesignjunction.com/wp-content/uploads/2024/08/creative_movie_posters_of_2024.jpg",
      duration: "25m",
      category: "Documentary",
      views: "2M",
      description: "Learn how it is originally distributed and mesmerizing sequence which shows how war takes 20 minutes to transport beyond and view space like this 2024% Learn how it is originally distributed and mesmerizing sequence which shows how war takes 20 minutes to transport beyond and view space like this 2024%",
      channelName: "Ben Channel",
    },
    {
      id: 2,
      title: "How the Space War Begin?",
      thumbnail: "https://graphicdesignjunction.com/wp-content/uploads/2024/08/creative_movie_posters_of_2024.jpg",
      duration: "25m",
      category: "Documentary",
      views: "2M",
      description: "Learn how it is originally distributed and mesmerizing sequence which shows how war takes 20 minutes to transport beyond and view space like this 2024%",
      channelName: "Ben Channel",
    },
    {
      id: 3,
      title: "How the Space War Begin?",
      thumbnail: "https://graphicdesignjunction.com/wp-content/uploads/2024/08/creative_movie_posters_of_2024.jpg",
      duration: "25m",
      category: "Documentary",
      views: "2M",
      description: "Learn how it is originally distributed and mesmerizing sequence which shows how war takes 20 minutes to transport beyond and view space like this 2024%",
      channelName: "Ben Channel",
    },
    {
      id: 4,
      title: "How the Space War Begin?",
      thumbnail: "https://graphicdesignjunction.com/wp-content/uploads/2024/08/creative_movie_posters_of_2024.jpg",
      duration: "25m",
      category: "Documentary",
      views: "2M",
      description: "Learn how it is originally distributed and mesmerizing sequence which shows how war takes 20 minutes to transport beyond and view space like this 2024%",
      channelName: "Ben Channel",
    },
    {
      id: 5,
      title: "How the Space War Begin?",
      thumbnail: "https://graphicdesignjunction.com/wp-content/uploads/2024/08/creative_movie_posters_of_2024.jpg",
      duration: "25m",
      category: "Documentary",
      views: "2M",
      description: "Learn how it is originally distributed and mesmerizing sequence which shows how war takes 20 minutes to transport beyond and view space like this 2024%",
      channelName: "Ben Channel",
    },
    {
      id: 6,
      title: "How the Space War Begin?",
      thumbnail: "https://graphicdesignjunction.com/wp-content/uploads/2024/08/creative_movie_posters_of_2024.jpg",
      duration: "25m",
      category: "Documentary",
      views: "2M",
      description: "Learn how it is originally distributed and mesmerizing sequence which shows how war takes 20 minutes to transport beyond and view space like this 2024%",
      channelName: "Ben Channel",
    },
    {
      id: 7,
      title: "How the Space War Begin?",
      thumbnail: "https://graphicdesignjunction.com/wp-content/uploads/2024/08/creative_movie_posters_of_2024.jpg",
      duration: "25m",
      category: "Documentary",
      views: "2M",
      description: "Learn how it is originally distributed and mesmerizing sequence which shows how war takes 20 minutes to transport beyond and view space like this 2024%",
      channelName: "Ben Channel",
    },
    {
      id: 8,
      title: "How the Space War Begin?",
      thumbnail: "https://graphicdesignjunction.com/wp-content/uploads/2024/08/creative_movie_posters_of_2024.jpg",
      duration: "25m",
      category: "Documentary",
      views: "2M",
      description: "Learn how it is originally distributed and mesmerizing sequence which shows how war takes 20 minutes to transport beyond and view space like this 2024%",
      channelName: "Ben Channel",
    },
  ];